import React, { useEffect, useState } from "react";
import "../styles/ReviewAvailablePage.css"; // ✅ 새 스타일 적용
import MyPageSidebar from "./MyPageSidebar";
import MyPageEmpty from "./MyPageEmpty";
import ReviewAvailableSection from "./ReviewAvailableSection"; // ✅ 새로운 컴포넌트

const ReviewAvailablePage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [reviews, setReviews] = useState([]);

    useEffect(() => {
        // 리뷰 가능한 상품 API 호출
        const getReviews = async () => {
            try {
                const response = await fetch("/api/mypage/reviewable-items");
                if (!response.ok) {
                    throw new Error("리뷰 가능한 상품 데이터 가져오기 실패");
                }
                const data = await response.json();
                setReviews(data.reviewableItems);
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        };

        getReviews();
    }, []);

    if (isLoading) return <p>로딩 중...</p>;

    if (reviews.length === 0) {
        return <MyPageEmpty text="리뷰 가능한 상품이 없습니다." />;
    }

    return (
        <div className="mypage-layout">
            <MyPageSidebar />
            <div className="mypage-review-available-list-container">
                <h2 className="mypage-title">리뷰 가능한 상품</h2>
                <ReviewAvailableSection reviews={reviews} />
            </div>
        </div>
    );
};

export default ReviewAvailablePage;
